
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/music-recap/yearly",
      function () {
        return require("private-next-pages/music-recap/yearly/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/music-recap/yearly"])
      });
    }
  